<template>
  <div>
    <!--顶部链接：会议系统等-->
    <div class="topNav">
      <ul class="right-top">
        <li class="right-top-li">
          <svg t="1712666124649" class="icon1" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4310" width="21" height="16"><path d="M627.712 527.104C819.029333 578.090667 960 752.597333 960 960a21.333333 21.333333 0 1 1-42.666667 0 405.333333 405.333333 0 0 0-810.666666 0 21.333333 21.333333 0 1 1-42.666667 0c0-207.402667 140.970667-381.866667 332.288-432.896a256 256 0 1 1 231.424 0zM512 512a213.333333 213.333333 0 1 0 0-426.666667 213.333333 213.333333 0 0 0 0 426.666667z" p-id="4311"></path></svg>
          <a href="https://member.nfsoc.org.cn" target="_blank">会员系统</a>
        </li>
        <li >
          <svg t="1712668874381" class="icon2" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5527" width="18" height="18"><path d="M174.08 309.76c-76.8 0-138.88-62.08-138.88-138.88S97.28 31.36 174.08 31.36s138.88 62.08 138.88 138.88S250.24 309.76 174.08 309.76zM174.08 69.76c-55.68 0-100.48 45.44-100.48 100.48s45.44 100.48 100.48 100.48 100.48-45.44 100.48-100.48S229.12 69.76 174.08 69.76z" fill="#515050" p-id="5528"></path><path d="M216.96 992.64l-60.16 0c-32.64 0-60.16-24.32-64-56.96 0-0.64 0-1.28 0-1.92l0-288c0-12.8-10.24-23.04-23.04-23.04L62.08 622.72c-0.64 0-0.64 0-1.28 0-33.28-1.92-59.52-28.16-60.8-60.8 0-1.28 0-1.92 0-3.2L0 373.12c0-33.92 27.52-61.44 61.44-61.44L473.6 311.68c33.92 0 61.44 27.52 61.44 61.44l0 7.04c0 33.28-26.88 60.8-60.8 61.44l-174.72 15.36c-10.88 2.56-19.84 11.52-21.76 22.4l0 451.84C278.4 965.12 250.88 992.64 216.96 992.64zM130.56 931.84c1.92 12.8 12.8 22.4 25.6 22.4l60.16 0c12.8 0 23.04-10.24 23.04-23.04L239.36 478.08c0-0.64 0-1.28 0-2.56 3.2-28.8 24.96-51.84 53.76-56.96 0.64 0 1.28 0 1.92 0L472.32 403.2c0.64 0 1.28 0 1.92 0 12.8 0 23.04-10.24 23.04-23.04l0-7.04c0-12.8-10.24-23.04-23.04-23.04L61.44 350.08c-12.8 0-23.04 10.24-23.04 23.04l0 181.76c0 0.64 0 1.92 0 2.56 0 13.44 10.88 24.96 24.32 26.24l6.4 0c33.92 0 61.44 27.52 61.44 61.44L130.56 931.84z" fill="#515050" p-id="5529"></path><path d="M962.56 745.6 332.16 745.6c-10.88 0-19.2-8.32-19.2-19.2s8.32-19.2 19.2-19.2l630.4 0c12.8 0 23.04-10.24 23.04-23.04L985.6 220.8c0-12.8-10.24-23.04-23.04-23.04L379.52 197.76c-10.88 0-19.2-8.32-19.2-19.2s8.32-19.2 19.2-19.2l583.04 0c33.92 0 61.44 27.52 61.44 61.44l0 463.36C1024 718.08 996.48 745.6 962.56 745.6z" fill="#515050" p-id="5530"></path><path d="M634.88 611.84c-1.28 0-1.92 0-3.2 0-7.04-1.28-12.8-6.4-15.36-13.44l-58.88-190.72c-3.2-10.24 2.56-21.12 12.8-24.32 10.24-3.2 21.12 2.56 24.32 12.8l47.36 153.6 95.36-133.12c3.84-5.12 8.96-7.68 15.36-8.32 6.4 0 11.52 2.56 15.36 7.68l47.36 61.44 78.08-161.28c3.2-6.4 9.6-10.88 17.28-10.88l46.08 0c10.88 0 19.2 8.32 19.2 19.2s-8.32 19.2-19.2 19.2l-33.92 0-86.4 178.56c-3.2 5.76-8.96 10.24-15.36 10.88-6.4 0.64-12.8-1.92-17.28-7.04l-50.56-65.28-103.04 143.36C647.04 608.64 640.64 611.84 634.88 611.84z" fill="#515050" p-id="5531"></path></svg>
          <a href="https://member.nfsoc.org.cn:8888" >会议系统</a>
        </li>
      </ul>
    </div>

    <div class="w1" theme4>
      <!--logo和搜索框-->
      <div class="logo-search">
        <div class="blue">
          <img src="../../../assets/img/logo6.png" alt="">
        </div>
        <!--搜索框-->
        <div class="search">
          <span class="iconfont" @click="goToSearch(this.inputValue)">&#xe78f;</span>
          <input type="text" placeholder="请输入关键字" @keyup.enter="goToSearch(this.inputValue)" v-model="this.inputValue">

        </div>
      </div>


      <!--导航菜单-->
      <div class="bottom">
        <div class="nav">
          <el-menu
            class="el-menu-demo"
            mode="horizontal"
            background-color="rgb(11, 54, 146)"
            text-color="#fff"
            :ellipsis="false"
          >
            <template v-for="item in silderList" :key="item.navigationId">
              <el-sub-menu @click="goToLevelOne(item)" v-if="item.mychildren.length > 1" :index="item.navigationId+''">
                <template #title>{{ item.navigationName }}</template>
                <el-menu-item @click="goToLevelTwo(item,item1)" v-for="item1 in item.mychildren" :index="item1.partId" :key="item1.partId">{{ item1.partName }}</el-menu-item>
              </el-sub-menu>
              <el-menu-item @click="goToLevelOne(item)" v-else :index="item.navigationId+''">{{ item.navigationName }}</el-menu-item>
            </template>
          </el-menu>
        </div>
      </div>
    </div>
  </div>


</template>
<script>
import {home1show, home1showNa, showSearchResult} from '../../../api/compoents'
import {useRouter} from 'vue-router'
import router from "@/router";

export default {
  name: 'appHeader1',
  data() {
    return {
      err: '', // 方便后续拿到错误信息
      loadFinish: false,
      silderList: [], // 将后端拿到的数据储存在data中
      searchResult: [],
      inputValue: '',
      showList:false,
      currentIndex:-1
    }
  },
  methods: {
    // 搜索
    async goToSearch(inputValue) {
      const href = router.resolve(`/search?keywords=${inputValue}`)
      window.open(href.href, '_blank')
      this.inputValue=''
    },
    async gethome1show() {
      try {
        const {data: res} = await home1show()
        if (res.code === 200) {
          console.log('狗屁',res.allNavigationList)

          res.allNavigationList.unshift({
            createBy: null,
            createTime: null,
            isApprove: 0,
            mychildren: [],
            navigationId: 0,
            navigationName: '首页',
            path: '/',
            params: {},
            remark: null,
            searchValue: null,
            updateBy: null,
            updateTime: null
          })
          const arr = res.allNavigationList
          console.log('什么玩意',arr)

          for (let i = 0; i < arr.length; i++) {
            try {
              const { data: res2 } = await home1showNa(arr[i].navigationId);
              if (res2.code === 200) {
                arr[i].mychildren = res2.allPartList[0].children;
                console.log('res2.allPartList[0].children', res2.allPartList[0].children);
              } else {     
                console.error('home1showNa failed with code', res2.code);
                // 处理错误，例如设置一个默认值或跳过当前迭代
              }
            } catch (err) {
              arr[i].mychildren = [{}]
              console.error('Error fetching children for navigation', arr[i].navigationId, err);
              // 处理错误，例如设置一个默认值或跳过当前迭代
            }

          }
          this.silderList = arr
          console.log('滚啊啊啊啊啊啊,silderList',this.silderList)
          console.log("太惨了姐");
        }
      } catch (err) {
        this.err = err.message
        window.$Ycom.$emit('y-com-newtip-addone', ['网络连接失败' + err.message, 5000, 'err'])
      }
      // 完整版（加入了一下安全处理）
      // try catch 是为了以防一些错误出现时，catch一个提示或者解决方案
    },

    // 点击一级菜单跳转
    goToLevelOne(i) {
      if (i.path) this.$router.push(i.path)
      else {
        this.$router.push(`/about?id=${i.navigationId}&navigationName=${i.navigationName}&logn=${'C'}&location=${'header'}`)
      }
    },
    // 点击架二级菜单跳转
    goToLevelTwo(item,item1) {
      this.$router.push(`/about?id=${item.navigationId}&navigationName=${item.navigationName}&partId=${item1.partId}&logn=${'C'}`)
    }
  },

  async mounted() {
    this.err = ''
    this.loadFinish = false
    // window.$Ycom.$emit('y-com-loading-chageShow', [true]) // loading  =》加载中组件
    await this.gethome1show()
    setTimeout(() => {
      this.loadFinish = true
    })
    // this.id = this.$route.query.id
    // this.navigationName = this.$route.query.name // route是当前页面获取路由跳转时传的参数，而router是路由跳转
  },

}

</script>
<style scoped lang="less">
::v-deep .el-icon svg {
  display: none;
}
.topNav{
  --h: calc(var(--xd--fontsize) * 2);
  z-index: 999;
  width: 100vw;
  height: calc(var(--h) * .4);
  line-height: calc(var(--h) * .4);
  border-bottom: 1px solid #dcdcdc;
  .right-top {
    display: flex;
    justify-content: flex-end;
    margin-right: calc(var(--h) );
    li {
      width: 110px;
      padding:0 calc(var(--h) * .2);
      //border-right:1px solid #ccc;
      font-size:14px;
      .icon1{
        position: relative;
        top: 2px;
        padding-right: 5px;
      }
      .icon2{
        position: relative;
        top: 4px;
        right: 4px;
      }
      a {
        color: #000;
      }
    }
    li:hover {
      cursor: pointer;
      color: #2292e3;
    }
    li:nth-child(2) {
      border-right:none;
    }
  }
}

.w1 {
  width: 100vw;
  .logo-search {
    display: flex;
    justify-content: space-around;
    align-items: center;
    .blue {
      float: left;
      margin-left: calc(var(--h) * 2);
      img {
        width: 30vw;
      }
    }
    .search {
      position: relative;
      --h: calc(var(--xd--fontsize) * 2);
      input {
        border:1.5px solid #ccc;
        height: calc(var(--h) * .7);
        width: calc(var(--h) * 5.5);
        border-radius: calc(var(--h) * .1);
        padding-left:calc(var(--h) * .7);
        font-size:calc(var(--h) * .25)
      }
      .iconfont {
        position: absolute;
        line-height: calc(var(--h) * .8);
        padding-left: calc(var(--h) * .2);
        font-weight:800;
        font-size: calc(var(--h) * .3);
      }
    }
  }
  .bottom {
    width: 100vw;
    margin-top:calc(var(--h) * 0.8) ;
    .nav {
      z-index:199;
      top: calc(var(--h) * 0.8);
      display: flex;
      width: 100vw;
      height: calc(var(--h) * .9);
      animation: show .3s;
      min-width: 67vw;
      overflow: hidden;
    }
  }
}
::v-deep .el-sub-menu__title , .el-menu-item {
  font-size: 16px;
}
::v-deep .el-menu--horizontal {
  width: 100vw;
  display: flex;
  justify-content: center;
  font-size: calc(var(--h) *.4);
}

@media screen and (max-width:1100px) {
  .topNav{
    display: none;
    --h: calc(var(--xd--fontsize) * 2);
    z-index: 999;
    width: 100vw;
    height: calc(var(--h) * .3);
    line-height: calc(var(--h) * .3);
    border-bottom: 1px solid #dcdcdc;
    .right-top {
      display: flex;
      justify-content: flex-end;
      margin-right: calc(var(--h) );
      li {
        width: calc(var(--h) * 1.5);
        padding:0 calc(var(--h) * .2);
        border-right:1px solid #ccc;
        font-size:calc(var(--h) * .2);
        a {
          color: #000;
        }
      }
      li:hover {
        cursor: pointer;
        color: #2292e3;
      }
      li:nth-child(2) {
        border-right:none;
      }
    }
  }
  .w1 {
    .logo-search {
      display: flex;
      justify-content: space-around;
      align-items: center;
      .blue {
        float: left;
        //margin-left: 30px;
        img {
          width: 70vw;
        }
      }
      .search {
        position: relative;
        --h: calc(var(--xd--fontsize) * 2);
        input {
          border:1.5px solid #ccc;
          height: calc(var(--h) * .5);
          width: calc(var(--h) * 2);
          border-radius: calc(var(--h) * .1);
          padding-left:calc(var(--h) * .4);
          font-size:calc(var(--h) * .2)
        }
        .iconfont {
          position: absolute;
          line-height: calc(var(--h) * .5);
          padding-left: calc(var(--h) * .1);
          font-weight:600;
        }
      }
    }
    .nav {
      z-index:77;
      position: relative;
      top:calc(var(--h) * .5);
      left:0;
      width: 100vw;

      ::v-deep .el-menu--horizontal {
        height:30px;
        line-height: 30px;
        width: 100vw;
        padding-right: 10px;
        display: flex;
        justify-content: flex-start;
        overflow-y: auto;
      }

      ::v-deep .el-menu--horizontal::-webkit-scrollbar {
        display: none;
      }

        ::v-deep .el-menu-item {
        padding: 0 8px;
        font-size: 11px;
      }
      ::v-deep .el-menu-item__title {
        padding-right: 0;
        font-size: calc(var(--h) * .1);
      }
      ::v-deep .el-sub-menu__title {
        padding: 0 8px;
        font-size: 11px;
      }
    }
}
/*  ::v-deep .el-menu-demo {
    padding:0!important;
  }

  ::v-deep .el-sub-menu__title , .el-menu-item {
    font-size: calc(var(--h) * .4)!important;
  }*/
}





@keyframes show {
  0% {
    opacity: 0;
  }
}

.w1::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
}

// 隐藏横纵向的滚动条
.nav > .menus {
  flex: 1;
  flex-shrink: 0;
  font-size: calc(var(--xd--fontsize) * 0.5);
  line-height: calc(var(--h) * .9);
  height: calc(var(--h) * .9);
  white-space: nowrap;
  font-weight: 530;
  cursor: pointer;
  .a {
    //color: #fff;
    height: calc(var(--h) * .9);
  }
  .a:hover{
    color: #2292e3;
    background-color: #fff;
  }
}

.menus-item {
  //z-index: 77!important;
  transition: all .25s;
  opacity: 0;
  font-size: inherit !important;
  border-bottom-right-radius: calc(var(--h) * .1);
  border-bottom-left-radius: calc(var(--h) * .1);
  background-color: #fff;
  li {
    //z-index: 77!important;
    font-size: inherit !important;
    border-radius: calc(var(--h) * .1);
  }
}

.menus:hover {
  z-index: 33;
  height: unset;
  overflow: visible;
  cursor: pointer;

  & > .menus-item {
    z-index: 33;
    opacity: 1;
    width: unset;
    cursor: pointer;
  }
}

.nav > li > .a {
  width: 100%;
  color: #fff;
  font-size: inherit !important;
  height: calc(var(--h) * 1.1);
  line-height: calc(var(--h) * 1.1);
  display: block;

}

/*@media screen and (max-width: 730px) {
  .big {
    --xd--fontsize: 1.5vmax !important;
  }
}
.el-menu-demo{
  padding: 0px 8vw;
}
.el-menu-item,.el-sub-menu{
  flex: 1;
  text-align: center;
}
.el-sub-menu__title{
  text-align: center;
  font-size:20px;
}*/
</style>
